<template>
  <div class="info">
    <van-tabs v-model="active">
      <van-tab title="基本信息">
        <Basic></Basic>
      </van-tab>
      <van-tab title="教育资格">
        <Education :toFrom='toFrom'></Education>
      </van-tab>
      <van-tab title="工作经历">
        <Work :toFrom='toFrom'></Work>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Basic from "./component/basic.vue";
import Education from "./component/education.vue";
import Work from "./component/work.vue";
export default {
  name: "info",
  components: {
    Basic,
    Education,
    Work,
  },
  data() {
    return {
      active: 0,
      toFrom:''
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.toFrom = from
      if (from.name === "addWork") {
        vm.active = 2;
      } else if(from.name === "home"){
        vm.active = 0;
      } else if(from.name === null){
        vm.active = 0;
      } else {
        vm.active = 1;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width:600px) {
  .info {
    width: 100%;
  }
}
@media screen and (min-width:600px) {
  .info {
    width: 276px * $zoom;
  }
}
.info {
  background: #f4f5f8;
  font-size: 16px * $zoom;
  min-height: 100vh;
  ::v-deep .van-tabs__wrap {
    height: 40px * $zoom !important;
    position: sticky;
    top: 0;
    z-index: 111;
  }
  ::v-deep .van-tab {
    font-size: 14pt;
  }
  ::v-deep .van-tabs__line {
    width: 60px * $zoom;
    border-bottom: 2px solid green;
    background: none;
  }
  ::v-deep .van-tabs__content {
    padding: 0 16pt;
  }
}
</style>
